// removed by extract-text-webpack-plugin
module.exports = {"container":"_29lEaj2s3XT-NcjkMWRe0-"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Templates/Template/Ready/styles.css
// module id = 2975
// module chunks = 0